import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../primitives/Tag/components/Container.js';
import { LabelSmallBold } from '../../primitives/Typography/index.js';
export const Tag = /*#__PURE__*/_styled(({
  children,
  variant = 'success',
  ...restProps
}) => _jsx(Container, {
  variant: variant,
  ...restProps,
  children: _jsx(LabelSmallBold, {
    color: variant === 'success' ? 'interactionSuccess' : 'systemError',
    textAlign: "center",
    children: children
  })
}), {
  label: 'Tag',
  target: "emphgh30"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlRhZy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNRyIsImZpbGUiOiJUYWcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgQ29udGFpbmVyIH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9UYWcvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuaW1wb3J0IHsgTGFiZWxTbWFsbEJvbGQgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL1R5cG9ncmFwaHkvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IFRhZyA9IHN0eWxlZCgoeyBjaGlsZHJlbiwgdmFyaWFudCA9ICdzdWNjZXNzJywgLi4ucmVzdFByb3BzIH0pID0+IChfanN4KENvbnRhaW5lciwgeyB2YXJpYW50OiB2YXJpYW50LCAuLi5yZXN0UHJvcHMsIGNoaWxkcmVuOiBfanN4KExhYmVsU21hbGxCb2xkLCB7IGNvbG9yOiB2YXJpYW50ID09PSAnc3VjY2VzcycgPyAnaW50ZXJhY3Rpb25TdWNjZXNzJyA6ICdzeXN0ZW1FcnJvcicsIHRleHRBbGlnbjogXCJjZW50ZXJcIiwgY2hpbGRyZW46IGNoaWxkcmVuIH0pIH0pKSwge1xuICAgIGxhYmVsOiAnVGFnJyxcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9VGFnLmpzLm1hcCJdfQ== */");